// Redux slice for managing soft tags, filters, and pagination
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { getSecondFeature } from './secondFeature.thunk';


// State shape for tags feature
interface SecondFeatureState {
    loading: boolean;
    secondFeatureData?: any; // Replace with actual data type
    error?: string | null;
}

// Initial state for tags slice
const initialState: SecondFeatureState = {
    loading: false,
    secondFeatureData: undefined,
    error: null,
};

// Slice for tags feature with reducers and extraReducers for async actions
const secondFeatureSlice = createSlice({
  name: 'secondFeature',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      // Handle getSoftTags pending state
      .addCase(getSecondFeature.pending, state => {
        state.loading = true;
        state.error = null;
      })

      // Handle getSecondFeature fulfilled state
      .addCase(
        getSecondFeature.fulfilled,
        (state, action: PayloadAction<any>) => {
            state.secondFeatureData = action.payload;
            state.loading = false;
        }
      )

      // Handle getSecondFeature rejected state
      .addCase(getSecondFeature.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

  },
});

// Export actions for use in components
export const {
setLoading
} = secondFeatureSlice.actions;

// Export reducer for store
export default secondFeatureSlice.reducer;
